import React, { useState, useRef, useCallback } from "react";
import DismissableModal from "components/DismissableModal";
import Form from "react-bootstrap/Form";
import { Row, Col, Button } from "react-bootstrap";
import { showNotification } from "services/NotificationService";
import { getErrorMessage } from "services/UtilityService";
import { unlinkDeclinedFax } from "views/Raw/FaxDisposition/FaxDispositionService";

const UnlinkDeclinedFax = ({ rawId, rawDetails, unlinkConfig, history }) => {
  const [notes, setNotes] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const modalRef = useRef("UnlinkFaxModal");

  const {
    notesPlaceholder = "Notes or comments about this response",
    notesControlId = "faxdisposition-form-notes",
    getWarningLines = () => ["Are you sure you want to unlink the fax?"],
  } = unlinkConfig ?? {};

  const warningLines = getWarningLines(rawDetails);

  const unlinkFaxClick = useCallback(async () => {
    setIsSubmitting(true);

    try {
      await unlinkDeclinedFax(rawId, notes);
      showNotification({
        title: "Successfully unlinked Fax!",
        message: "The fax has been successfully unlinked.",
        position: "tr",
        type: "success",
      });
      modalRef.current.handleClose();
      history(-1);
    } catch (error) {
      showNotification({
        title: "Error!",
        message:
          getErrorMessage(error?.data) ||
          getErrorMessage("SOMETHING_WENT_WRONG"),
        position: "tr",
        type: "error",
      });
    } finally {
      setIsSubmitting(false);
    }
  }, [rawId, notes, history]);

  return (
    <DismissableModal
      title="Unlink Fax"
      ref={modalRef}
      initialStateOpen={showModal}
      openModalButtonText="Unlink Fax"
      openModalButtonBlock={false}
      openModalButtonStyle="danger"
      size="lg"
    >
      <Form.Group>
        <Form.Label>Notes are Required</Form.Label>
        <Form.Control
          id={notesControlId}
          as="textarea"
          rows={3}
          placeholder={notesPlaceholder}
          onChange={(e) => setNotes(e.target.value)}
          value={notes}
          name="notes"
          disabled={isSubmitting}
        />
        <Form.Text className="text-muted">
          {warningLines.map((line, index) => (
            <React.Fragment key={line}>
              {line}
              {index < warningLines.length - 1 ? (
                <>
                  <br />
                  <br />
                </>
              ) : null}
            </React.Fragment>
          ))}
        </Form.Text>
        <Row className="top-spacer">
          <Col md={4} className="bottom-spacer">
            <Button
              type="submit"
              variant="success"
              block
              disabled={isSubmitting || notes === ""}
              onClick={unlinkFaxClick}
            >
              {isSubmitting ? "Unlinking" : "Yes"}
            </Button>
          </Col>
        </Row>
      </Form.Group>
    </DismissableModal>
  );
};

export default UnlinkDeclinedFax;
